module.exports = __webpack_public_path__ + "img/PV.30852699.svg";